import { FormConfig } from '@shared/interfaces/form-configs/form-config';
import {
  CreateMeteringPointCommand,
  ProductCharacteristicIdentification,
  ProductCharacteristicUnitType
} from '@app/api/dmc';

export const meteringPointTypeElectricalHeatingFormConfig: FormConfig<CreateMeteringPointCommand> = {
  'detailCharacteristics.productCharacteristicIdentification': {
    value: ProductCharacteristicIdentification.EnergyActive,
    state: 'required',
  },
  'detailCharacteristics.productCharacteristicUnitType': {
    value: ProductCharacteristicUnitType.KWH,
    state: 'required',
  },
  'detailCharacteristics.fromGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.toGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.netSettlementGroup': {
    state: 'disabled',
  },
  'detailCharacteristics.disconnectionType': {
    state: 'disabled',
  },
  'detailCharacteristics.settlementMethod': {
    state: 'disabled',
  },
  'detailCharacteristics.capacity': {
    state: 'disabled',
  },
  'detailCharacteristics.powerPlantIdentification': {
    state: 'disabled',
  },
  'detailCharacteristics.assetType': {
    state: 'disabled',
  },
  'detailCharacteristics.connectionType': {
    state: 'disabled',
  },
  'parentMeteringPointIdentification': {
    state: 'optional',
  },
  'connectionPointId': {
    state: 'disabled',
  },
  // TS-Ignore necessary to reference a field that doesn't exist.
  // @ts-expect-error TS2353: extra property
  'connectionPointIdentification': {
    state: 'disabled',
    optional: true,
  },
  'connectionPointAddress': {
    state: 'disabled',
    optional: true,
  }
}
